// A motion veto, never a claim that an accelerometer can prove vehicle speed.
export function motionReading(event, now) {
  const a = ['x', 'y', 'z'].map(axis => event.acceleration?.[axis]);
  const r = ['alpha', 'beta', 'gamma'].map(axis => event.rotationRate?.[axis]);
  if (![...a, ...r].every(Number.isFinite)) return { state: 'unknown', capturedAt: now };
  return { state: Math.hypot(...a) > 0.2 || Math.hypot(...r) > 1 ? 'moving' : 'quiet', capturedAt: now };
}

export function createLearningMotion({ host, onReading }) {
  let generation = 0;
  let receive;
  let visibility;
  const stop = () => {
    generation++;
    if (receive) host.removeEventListener('devicemotion', receive);
    if (visibility) host.document.removeEventListener('visibilitychange', visibility);
    receive = visibility = null;
  };
  return {
    stop,
    async start() {
      stop();
      const token = generation;
      onReading({ state: 'unknown', capturedAt: Date.now() });
      try {
        const api = host.DeviceMotionEvent;
        if (!host.isSecureContext || !api) throw Error('unavailable');
        const permission = typeof api.requestPermission === 'function' ? await api.requestPermission() : 'granted';
        if (token !== generation) return;
        if (permission !== 'granted') throw Error('denied');
        let last = -Infinity;
        let lastState;
        receive = event => {
          if (token !== generation || !event.isTrusted || host.document.visibilityState !== 'visible') return;
          const now = Date.now();
          const reading = motionReading(event, now);
          // Only quiet/repeated readings may be throttled. A movement veto or
          // lost measurement must reach the gate even between quiet updates.
          // Also hold that veto through this interval instead of immediately
          // replacing it with quiet when a brief motion pulse ends.
          if (now - last < 100 && (reading.state === 'quiet' || reading.state === lastState)) return;
          last = now;
          lastState = reading.state;
          onReading(reading);
        };
        visibility = () => {
          if (host.document.visibilityState !== 'visible') onReading({ state: 'unknown', capturedAt: Date.now() });
        };
        host.addEventListener('devicemotion', receive);
        host.document.addEventListener('visibilitychange', visibility);
      } catch {
        if (token === generation) onReading({ state: 'unavailable', capturedAt: Date.now() });
      }
    },
  };
}

